import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AppProviders } from './app-providers';
import { createRouter } from './router';
import { authService } from '@/features/auth/model/auth-service';
import '../index.css';

async function initializeApp() {
	// Initialize MSAL and handle any redirect response from Azure AD
	await authService.initialize();

	// Create router AFTER auth is initialized so loaders have correct auth state
	const router = createRouter();

	createRoot(document.getElementById('root')!).render(
		<StrictMode>
			<AppProviders>
				<RouterProvider router={router} />
			</AppProviders>
		</StrictMode>
	);
}

initializeApp();
